<script setup>
const { injectSkinClasses } = useSkins()

// ℹ️ This will inject classes in body tag for accurate styling
injectSkinClasses()

const toastRef = ref()

provide('toast', {
  error: msg => toastRef.value?.triggerToast(msg, 'error'),
  success: msg => toastRef.value?.triggerToast(msg, 'success'),
  warning: msg => toastRef.value?.triggerToast(msg, 'warning'),
})
</script>

<template>
  <div class="layout-wrapper layout-blank">
    <slot />
    <AppToast ref="toastRef" />
  </div>
</template>

<style>
.layout-wrapper.layout-blank {
  flex-direction: column;
}
</style>
